import LimitedColorPicker from "../components/LimitedColorPicker";
import Editor from "../components/Editor/Editor";
// import Box from "../assests/Images/RingBox.png";
// import GiftBags from "../assests/Images/LuxuryGiftBags.png";
// import WrappingPaper from "../assests/Images/TISSUE.png";
// import Stickers from "../assests/Images/STICKERS.png";
// import Receipt from "../assests/Images/RECEIPTWALLET.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import rightArrow from "../assests/rightArrow.png";
import leftArrow from "../assests/leftArrow.png";
import { GlobalStateContext } from "../App";

const Data = [
  {
    id: 1,
    name: "LUXURY RING BOX",
  },
  {
    id: 2,
    name: "LUXURY GIFT BAGS",
  },
  {
    id: 3,
    name: "TISSUE PAPER",
  },
  {
    id: 4,
    name: "STICKERS",
  },
  {
    id: 5,
    name: "RECEIPT WALLET - Cover",
  },
  {
    id: 6,
    name: "RECEIPT WALLET - Inside",
  },
];

export default function Customizer() {
  let [params, setParams] = useSearchParams();
  const [stageVal, setStage] = useState(parseInt(params.get("stage")) || 0);

  const navigator = useNavigate();

  useEffect(() => {
    localStorage.setItem("highestStage",stageVal+1)
    navigator(`/customizer?stage=${stageVal}`);
  }, [stageVal]);

  useEffect(() => {
    setStage(parseInt(params.get("stage")));
  }, [params]);

  const handleIdAdd = () => {
    if(stageVal < 5) setStage(stageVal + 1);
  };

  const handleIdSub = () => {
    if(stageVal > 0) setStage(stageVal - 1);
  };

  return (
    <>
      {/* Stages List Start */}
      <div className="flex gap-2 m-12 justify-center">
        {Data?.map((element, index) => (
          <button
            key={index}
            onClick={() => setStage(element.id - 1)}
            style={{ fontFamily: "ZapfHumanistBold" }}
            className={`bg-white px-1 py-3 rounded-lg text-[14px] w-[182px] focus:border border-solid] ${
              index == stageVal && `border border-[#0F0F0F] border-solid]`
            }`}
          >
            {element.name}
          </button>
        ))}
      </div>
      {/* Stages List End */}
      <div className="flex justify-center items-center gap-6 mb-[100px] relative">
        {stageVal > 0 && (
          <div
            className="bg-black z-30 fixed top-[50%] left-[-40px] lg:left-[50px] pl-[50px] lg:pl-4 rounded-full p-6 w-[80px] h-[80px] flex justify-center items-center cursor-pointer"
            onClick={handleIdSub}
          >
            <span className="transition-transform duration-300 hover:scale-110">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="60"
                height="60"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </span>
          </div>
        )}
        <Editor data={Data[stageVal]} stage={stageVal} save={handleIdAdd} />
        {stageVal < 5 && (
          <div
            className="bg-black z-30 fixed top-[50%] right-[-40px] lg:right-[50px] pr-[50px] lg:pr-4 rounded-full p-4 w-[80px] h-[80px] flex justify-center items-center text-center cursor-pointer"
            onClick={handleIdAdd}
          >
            <span className="transition-transform duration-300 hover:scale-110">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="60"
                height="60"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            </span>
          </div>
        )}
      </div>
    </>
  );
}
